import { DataQualityInfograph } from './DataQualityInfograph';
import { useCinematicReveal } from '../../hooks/useCinematic';
import { useReportTheme } from '../../contexts/ReportThemeContext';
import { HealthDimension } from '../../types/report';

interface CinematicHealthAndDimensionsProps {
    healthScore: number;
    healthDimensions?: HealthDimension[];
    datasetMeta: {
        name: string;
        rows: number;
        columns: number;
    };
    userRulesData?: any; // User-prescribed rules data - if provided, will show in DataQualityInfograph
}

export function CinematicHealthAndDimensions({
    healthScore,
    healthDimensions,
    userRulesData
}: CinematicHealthAndDimensionsProps) {
    const { ref, headerVisible, contentVisible } = useCinematicReveal({ headerDelay: 100, contentDelay: 400 });
    const { getThemeClasses } = useReportTheme();
    const themeClasses = getThemeClasses();



    return (
        <section
            ref={ref}
            id="dimensions"
            data-legacy-id="data-analysis"
            className={`min-h-screen py-24 px-6 relative overflow-hidden flex items-center ${themeClasses.sectionBackground}`}
        >
            {/* Animated background effects */}
            <div className="absolute inset-0">
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-white/5 via-transparent to-transparent opacity-30" />
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_var(--tw-gradient-stops))] from-white/8 via-transparent to-transparent opacity-30" />
            </div>

            <div className="relative z-10 w-full max-w-6xl mx-auto">
                {/* Main content with staged reveal */}
                <div
                    style={{
                        opacity: contentVisible ? 1 : 0,
                        transition: 'opacity 0.5s ease-out'
                    }}
                >
                    <div className="relative">
                        {/* Optimized cinematic card with better proportions */}
                        <div className={`mx-auto w-full backdrop-blur-2xl rounded-xl p-12 md:p-20 border ${themeClasses.cardBorder} shadow-md max-w-6xl overflow-hidden min-h-[600px] ${themeClasses.cardBackground}`}>
                            {/* Layered ambience */}
                            <div className="pointer-events-none absolute inset-0">
                                <div className="absolute inset-0 bg-gradient-to-tr from-black/10 via-transparent to-black/5" />
                                <div className="absolute -top-24 -left-20 w-60 h-60 bg-black/10 rounded-full blur-3xl" />
                                <div className="absolute -bottom-24 -right-20 w-60 h-60 bg-black/10 rounded-full blur-3xl" />
                            </div>

                            <div className="relative z-10 flex flex-col items-center min-h-[500px]">
                                <DataQualityInfograph
                                    bare
                                    healthScore={healthScore}
                                    healthDimensions={healthDimensions || []}
                                    className="max-w-6xl w-full"
                                    userRulesData={userRulesData}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
